<div>
    <div class="card p-2 m-2" *ngIf="!enableNewMappingPage && !enableUpdateMappingPage">
        <div class="Tabletitle">
            <span class="Tabletitle"> Redaction Mapping Table </span>
        </div>

        <div>
            <button class="m-1" mat-raised-button (click)="enableNewMapping('new')">Create New Mapping</button>
            <mat-form-field class="element-filter" *ngIf="redactionMappingTableArray">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
                
            </mat-form-field>
            <div class="m-1 mt-1" *ngIf=redactionMappingTableArray style="float:right">
                (Total Count: {{redactionMappingTableArray.length}})
            </div>
        </div>

        <table style="width: 100%;" mat-table [dataSource]="redactionMappingDataSource" class="mat-elevation-z8 mt-2">

            <ng-container matColumnDef="catName">
                <th mat-header-cell *matHeaderCellDef><b>CATEGORY NAME</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element.catName}}</td>
            </ng-container>


            <ng-container matColumnDef="redactedCatName">
                <th mat-header-cell *matHeaderCellDef><b>REDACTED CATEGORY NAME</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element.redactedCatName}}</td>
            </ng-container>

            <!-- <ng-container matColumnDef="reviewCatName">
                <th mat-header-cell *matHeaderCellDef><b>REVIEW CATEGORY NAME</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element.reviewCatName}}</td>
            </ng-container> -->

            <ng-container matColumnDef="redactionProfile">
                <th mat-header-cell *matHeaderCellDef><b>REDACTION PROFILE NAME</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element.redactionProfile}}</td>
            </ng-container>

            <ng-container matColumnDef="confidenceLevel">
                <th mat-header-cell *matHeaderCellDef><b>CONFIDENCE LEVEL</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element['Confidence Threshold']}}</td>
            </ng-container>

            <ng-container matColumnDef="forceReview">
                <th mat-header-cell *matHeaderCellDef><b>MANUAL REVIEW</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element['Force Review'] === true ? 'Yes':'No'}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef><b>ACTIONS</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">
                    <mat-icon (click)="enableNewMapping('update', element)">edit</mat-icon>
                    <mat-icon (click)="deleteMapping(element['Category Id'])">delete</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="card p-2 m-2" *ngIf="enableNewMappingPage || enableUpdateMappingPage">
        <div>
            <div class="Tabletitle">{{enableNewMappingPage ? 'Create New Redaction Mapping':'Update Redaction Mapping'}}
            </div>

            <div class="card m-2">
                <form [formGroup]="mappingForm" class="card-body">

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Unredacted Category</span>
                        </div>
                        
                        <mat-select formControlName="category" class="form-control" (selectionChange)="categorySelected($event)">
                            <input (focusout)="focusOutFunction('category')" (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [(ngModel)]="categorySearch" placeholder="search" [ngModelOptions]="{standalone: true}" class="form-control">
                            <mat-option *ngFor="let cat of filteredCategories" [value]="cat">
                                {{cat['name']}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Redacted Category</span>
                        </div>
                    
                        <mat-select formControlName="redactedCategory" class="form-control" (selectionChange)="redactedCategorySelected($event)">
                            <input (focusout)="focusOutFunction('redactionCat')" (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [(ngModel)]="redactedCategoryName" placeholder="search" [ngModelOptions]="{standalone: true}" class="form-control">
                            <mat-option *ngFor="let cat of filteredRedactedCategories" [value]="cat">
                                {{cat['name']}}
                            </mat-option>
                            <!-- <mat-option *ngIf="filteredRedactedCategories && filteredRedactedCategories.length === 0" [hidden]="redactedCategoryName == ''" [value]="-1">
                                <div style="width: 100%; text-align: start;" class="btn btn-light">{{redactedCategoryName}} Redacted</div>
                            </mat-option> -->
                        </mat-select>
                        <!-- <label *ngIf="redactedCategoryName != ''" style="font-size: small;" class="m-0 col-12 p-0">A 'redacted' word will be added at the end of the category name</label> -->
                    </div>

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Virtual Folder</span>
                        </div>
                    
                        <mat-select formControlName="reviewVirtualFolder" class="form-control" (selectionChange)="reviewVirtualFolderSelected($event)">
                            <input (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [(ngModel)]="reviewVirtualFolderSearch" placeholder="search" [ngModelOptions]="{standalone: true}" class="form-control">
                            <mat-option *ngFor="let folder of filteredReviewVirtualFolders" [value]="folder">
                                {{folder['folder_name']}}
                            </mat-option>
                            <mat-option style="padding: 0%;" *ngIf="filteredReviewVirtualFolders && filteredReviewVirtualFolders.length === 0" [hidden]="reviewVirtualFolderSearch == ''" [value]="-1">
                                <div style="width: 100%; text-align: start;" class="btn btn-light">{{reviewVirtualFolderSearch}}</div>
                            </mat-option>
                        </mat-select>
                    </div>               

                    <!-- <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Review Virtual Folder Name</span>
                        </div>
                        <mat-select formControlName="reviewCategory" class="form-control" (selectionChange)="reviewCategorySelected($event)">
                            <input (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [(ngModel)]="reviewCategoryName" placeholder="search" [ngModelOptions]="{standalone: true}" class="form-control">
                            <mat-option *ngFor="let cat of filteredReviewCategories" [value]="cat">
                                {{cat['name']}}
                            </mat-option>
                            <mat-option *ngIf="filteredReviewCategories && filteredReviewCategories.length === 0" [hidden]="reviewCategoryName == ''" [value]="-1">
                                <button style="width: 100%; text-align: start;" class="btn btn-light">{{reviewCategoryName}} Review</button>
                            </mat-option>
                            
                        </mat-select>
                        <label  [(ngModel)]="reviewVFName" [ngModelOptions]="{standalone: true}" class="form-control"></label>
                        <label *ngIf="reviewVFName != ''" style="font-size: small;" class="m-0 col-12 p-0">'VF' will be added at the end of the virtual folder name</label>
                    </div> -->

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Redaction Profile</span>
                        </div>

                        <mat-select formControlName="redactionProfile" class="form-control" (selectionChange)="redactionProfileSelected($event)">
                            <input (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [(ngModel)]="redactionProfileSearch" placeholder="search" [ngModelOptions]="{standalone: true}" class="form-control">
                            <mat-option *ngFor="let profile of filteredRedactionProfiles" [value]="profile">
                                {{profile['Profile Name']}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <!-- <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Copy Permissions from Parent Category</span>
                        </div>

                        <mat-slide-toggle (change)="copyParentPermsChanged($event)" class="pl-2 pr-2 ml-3 align-self-center" formControlName="copyParentPermissions"></mat-slide-toggle>
                    </div> -->

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Confidence Level</span>
                        </div>
                        <input title="Enter a number between 50 and 100" type="number" min="50" max="100" formControlName="confidenceLevel" [class]="mappingForm.get('confidenceLevel').value != '' && !mappingForm.get('confidenceLevel').valid ? 'form-control invalid' : 'form-control' " id="confidenceLevel" name="confidenceLevel">
                    </div>

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend" style="display: block;">
                            <span class="input-group-text form-label-105 w-100">Manual Review</span>
                        </div>

                        <mat-slide-toggle class="pl-2 pr-2 ml-3 align-self-center" formControlName="forceReview"></mat-slide-toggle>
                    </div>

                    <!-- Permissions -->
                    <!-- <div class="mt-2 mb-3 col-12" formGroupName="permissionsForParentCategory">
                        <label class="font-weight-bold mr-2 col-12 p-0">{{ mappingForm['value']['category'] ? 'Set Permissions for ' + mappingForm['value']['category']['name']:'Set Permissions for Parent Category'}} :
                        </label>
                        <div class="col-6 p-0 mr-2" *ngFor="let arr of trialArray; let index=index;">
                            <div *ngIf="index == 0" class="input-group-sm mb-1 input-group">
                                <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                        'Redact Document': index == 1 ? 'Redact Document':''}}</span>
                                </div>
                                <mat-select [ngModel]="index == 0 ? redactDocPerm:redactDocPerm"
                                    (ngModelChange)="index == 0 ? redactDocPerm = $event:redactDocPerm = $event" multiple
                                    name="{{index == 0 ? 'redact_document':index == 1 ? 'redact_document':''}}"
                                    formControlName="{{index == 0 ? 'redact_document':index == 1 ? 'redact_document':''}}"
                                    class="form-control">
                                    <mat-option>
                                        <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                            [noEntriesFoundLabel]="'Not found'" name="search"
                                            [ngModelOptions]="{standalone: true}">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                        [value]="user">
                                        {{user}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div> -->


                    <!-- <div class="mt-2 mb-3 col-12" formGroupName="permissionsForRedactCategory" *ngIf="displaySubCatPerms">
                        <label class="font-weight-bold mr-2 col-12 p-0">{{ mappingForm['value']['redactedCategory'] &&  mappingForm['value']['redactedCategory'] != '-1' ? 'Set Permissions for ' + mappingForm['value']['redactedCategory']['name']:'Set Permissions for Redacted Category'}} : 
                        </label>
                        <div class="row">
        
                            <div *ngIf="copiedGroups && copiedGroupsForCat && copiedGroupsForCat=='redact' " class="col-12">
                                <div class="input-group-sm input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Copy Permissions from
                                            {{permissionName}} to</span>
                                    </div>
                                    <mat-select [(ngModel)]="commonPermissions" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="commonPermissions" multiple class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <div *ngFor="let permission of permissionsList |stringFilter:searchCtrl:'name'">
                                            <mat-option *ngIf="permissionName!=permission" [value]="permission">
                                                {{permission}}
                                            </mat-option>
                                        </div>
                                    </mat-select>
                                    <mat-icon (click)="closeCopyGroups()">close</mat-icon>
                                </div>
                                <button mat-stroked-button (click)="cloneGroups()"
                                    style="margin: 2px;float: right;">Copy</button>
                            </div>
        
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Add Document': index == 1 ? 'Get Document':'View Document'}} </span></div>
                                    <mat-select
                                        [ngModel]="index == 0 ? addDocPermRedact: index == 1 ? getDocPermRedact:viewDocPermRedact"
                                        (ngModelChange)="index == 0 ? addDocPermRedact = $event: index == 1 ? getDocPermRedact = $event:viewDocPermRedact = $event"
                                        formControlName="{{index == 0 ? 'add_document':index == 1 ? 'get_document':'view_document'}}"
                                        multiple
                                        name="{{index == 0 ? 'add_document':index == 1 ? 'get_document':'view_document'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? addDocPermRedact.length>0: index == 1 ? getDocPermRedact.length > 0:viewDocPermRedact.length>0">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(addDocPermRedact,'Add Document','redact'):index == 1 ? copyGroups(getDocPermRedact,'Get Document', 'redact'):copyGroups(viewDocPermRedact,'View Document', 'redact')">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Update Document': index == 1 ? 'Delete Document':'Create Category'}}</span></div>
                                    <mat-select
                                        [ngModel]="index == 0 ? updateDocPermRedact: index == 1 ? deleteDocPermRedact:createCatPermRedact"
                                        (ngModelChange)="index == 0 ? updateDocPermRedact = $event: index == 1 ? deleteDocPermRedact = $event:createCatPermRedact = $event"
                                        multiple
                                        name="{{index == 0 ? 'update_document':index == 1 ? 'delete_document':'create_category'}}"
                                        formControlName="{{index == 0 ? 'update_document':index == 1 ? 'delete_document':'create_category'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? updateDocPermRedact.length>0: index == 1 ? deleteDocPermRedact.length > 0:createCatPermRedact.length>0">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(updateDocPermRedact,'Update Document','redact'):index == 1 ? copyGroups(deleteDocPermRedact,'Delete Document','redact'):copyGroups(createCatPermRedact,'Create Category','redact') ">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Get Category': index == 1 ? 'Update Category':'Delete Category'}}</span></div>
                                    <mat-select
                                        [ngModel]="index == 0 ? getCatPermRedact: index == 1 ? updateCatPermRedact:deleteCatPermRedact"
                                        (ngModelChange)="index == 0 ? getCatPermRedact = $event: index == 1 ? updateCatPermRedact  = $event :deleteCatPermRedact = $event"
                                        multiple
                                        name="{{index == 0 ? 'get_category':index == 1 ? 'update_category':'delete_category'}}"
                                        formControlName="{{index == 0 ? 'get_category':index == 1 ? 'update_category':'delete_category'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? getCatPermRedact.length>0: index == 1 ? updateCatPermRedact.length > 0:deleteCatPermRedact.length>0 ">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(getCatPermRedact,'Get Category','redact') : index == 1 ? copyGroups(updateCatPermRedact,'Update Category','redact'):copyGroups(deleteCatPermRedact,'Delete Category','redact')">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div *ngIf="index == 0 || index == 1" class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Compliance': index == 1 ? 'Redact Document':''}}</span>
                                    </div>
                                    <mat-select [ngModel]="index == 0 ? compliancePermRedact:redactDocPermRedact"
                                        (ngModelChange)="index == 0 ? compliancePermRedact = $event:redactDocPermRedact = $event"
                                        multiple name="{{index == 0 ? 'compliance':index == 1 ? 'redact_document':''}}"
                                        formControlName="{{index == 0 ? 'compliance':index == 1 ? 'redact_document':''}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? compliancePermRedact.length>0: index == 1 ? redactDocPermRedact.length>0:null">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(compliancePermRedact,'Compliance','redact') : index == 1 ? copyGroups(redactDocPermRedact,'Redact Document','redact'):null">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="mt-2 mb-3 col-12" formGroupName="permissionsForReviewCategory" *ngIf="displaySubCatPerms">
                        <label for="permission" class="font-weight-bold mr-2 col-12 p-0">{{ mappingForm['value']['reviewCategory'] &&  mappingForm['value']['reviewCategory'] != '-1' ? 'Set Permissions for ' + mappingForm['value']['reviewCategory']['name']:'Set Permissions for Review Category'}} : 
                        </label>
                        <div class="row">
        
                            <div *ngIf="copiedGroups && copiedGroupsForCat && copiedGroupsForCat=='review'" class="col-12">
                                <div class="input-group-sm input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Copy Permissions from
                                            {{permissionName}} to</span>
                                    </div>
                                    <mat-select [(ngModel)]="commonPermissions" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="commonPermissions" multiple class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <div *ngFor="let permission of permissionsList |stringFilter:searchCtrl:'name'">
                                            <mat-option *ngIf="permissionName!=permission" [value]="permission">
                                                {{permission}}
                                            </mat-option>
                                        </div>
                                    </mat-select>
                                    <mat-icon (click)="closeCopyGroups()">close</mat-icon>
                                </div>
                                <button mat-stroked-button (click)="cloneGroups()"
                                    style="margin: 2px;float: right;">Copy</button>
                            </div>
        
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Add Document': index == 1 ? 'Get Document':'View Document'}} </span></div>
                                    <mat-select
                                        [(ngModel)]="index == 0 ? addDocPermReview: index == 1 ? getDocPermReview:viewDocPermReview"
                                        (ngModelChange)="index == 0 ? addDocPermReview = $event: index == 1 ? getDocPermReview = $event:viewDocPermReview = $event"
                                        formControlName="{{index == 0 ? 'add_document':index == 1 ? 'get_document':'view_document'}}"
                                        multiple
                                        name="{{index == 0 ? 'add_document':index == 1 ? 'get_document':'view_document'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? addDocPermReview.length>0: index == 1 ? getDocPermReview.length > 0:viewDocPermReview.length>0">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(addDocPermReview,'Add Document','review'):index == 1 ? copyGroups(getDocPermReview,'Get Document','review'):copyGroups(viewDocPermReview,'View Document','review')">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Update Document': index == 1 ? 'Delete Document':'Create Category'}}</span></div>
                                    <mat-select
                                        [ngModel]="index == 0 ? updateDocPermReview: index == 1 ? deleteDocPermReview:createCatPermReview"
                                        (ngModelChange)="index == 0 ? updateDocPermReview = $event: index == 1 ? deleteDocPermReview = $event:createCatPermReview = $event"
                                        multiple
                                        name="{{index == 0 ? 'update_document':index == 1 ? 'delete_document':'create_category'}}"
                                        formControlName="{{index == 0 ? 'update_document':index == 1 ? 'delete_document':'create_category'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? updateDocPermReview.length>0: index == 1 ? deleteDocPermReview.length > 0:createCatPermReview.length>0">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(updateDocPermReview,'Update Document','review'):index == 1 ? copyGroups(deleteDocPermReview,'Delete Document','review'):copyGroups(createCatPermReview,'Create Category','review') ">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Get Category': index == 1 ? 'Update Category':'Delete Category'}}</span></div>
                                    <mat-select
                                        [ngModel]="index == 0 ? getCatPermReview: index == 1 ? updateCatPermReview:deleteCatPermReview"
                                        (ngModelChange)="index == 0 ? getCatPermReview = $event: index == 1 ? updateCatPermReview = $event:deleteCatPermReview = $event"
                                        multiple
                                        name="{{index == 0 ? 'get_category':index == 1 ? 'update_category':'delete_category'}}"
                                        formControlName="{{index == 0 ? 'get_category':index == 1 ? 'update_category':'delete_category'}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? getCatPermReview.length>0: index == 1 ? updateCatPermReview.length > 0:deleteCatPermReview.length>0 ">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(getCatPermReview,'Get Category','review') : index == 1 ? copyGroups(updateCatPermReview,'Update Category','review'):copyGroups(deleteCatPermReview,'Delete Category','review')">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4" *ngFor="let arr of trialArray; let index=index;">
                                <div *ngIf="index == 0 || index == 1" class="input-group-sm mb-1 input-group">
                                    <div class="input-group-prepend"><span class="input-group-text form-label-50">{{index == 0 ?
                                            'Compliance': index == 1 ? 'Redact Document':''}}</span>
                                    </div>
                                    <mat-select [ngModel]="index == 0 ? compliancePermReview:redactDocPermReview"
                                        (ngModelChange)="index == 0 ? compliancePermReview = $event:redactDocPermReview = $event"
                                        multiple name="{{index == 0 ? 'compliance':index == 1 ? 'redact_document':''}}"
                                        formControlName="{{index == 0 ? 'compliance':index == 1 ? 'redact_document':''}}"
                                        class="form-control">
                                        <mat-option>
                                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                                [noEntriesFoundLabel]="'Not found'" name="search"
                                                [ngModelOptions]="{standalone: true}">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let user of usersList | stringFilter:searchCtrl:'name'"
                                            [value]="user">
                                            {{user}}
                                        </mat-option>
                                    </mat-select>
                                    <span
                                        *ngIf="index == 0 ? compliancePermReview.length>0: index == 1 ? redactDocPermReview.length>0:null">
                                        <mat-icon class="clone-icon"
                                            (click)="index == 0 ? copyGroups(compliancePermReview,'Compliance','review') : index == 1 ? copyGroups(redactDocPermReview,'Redact Document','review'):null">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <button mat-raised-button class="backButton m-1" (click)="back()">Back</button>
                    <button mat-raised-button class="actionButton m-1" [disabled]="!mappingForm.valid" *ngIf="button === 'Save'" (click)="save()">{{button}}</button>
                    <button mat-raised-button class="actionButton m-1" [disabled]="!mappingForm.valid" *ngIf="button === 'Update'" (click)="save()">{{button}}</button>

                </form>
            </div>
        </div>
    </div>

    <ng-template #deleteMappingPopup>
        <div class="card mt-3">
            <div class="card-body" style="text-align: center;">
                <div class="container" style="height: auto;">
                    <h5>Are you sure you want to delete the selected Mapping?</h5>
                    <div class="row mt-3 mb-3" style="height: auto;">
                        <div class="col-12">
                            <button mat-close mat-flat-button style="float: right;" class="ml-2 backButtonColor"
                                (click)="confirmDeleteMapping('close')">No</button>
                            <button mat-close mat-flat-button style="float: right;" (click)="confirmDeleteMapping('delete')" class="actionButtonColor">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>